<template>
  <div class="statistics">
    <header>
      <span @click="backtrack" style="cursor:pointer">返回</span>
      项目统计
    </header>
    <main>
      <h3>
        <!-- <div
          v-for="(item, index) in statisticsTit"
          :class="titActiveI==index ? 'titActive' :''"
          :key="index"
          @click="titActive(item, index)"
        >{{item}}</div>-->
        <div :class="qwe ? 'titActive' : ''" @click="to('0')">项目统计</div>
        <!-- <router-link to="/projectHome/interpreter"> -->
          <div :class="!qwe ? 'titActive' : ''" @click="to('1')">译员工作量</div>
        <!-- </router-link> -->
      </h3>
      <div class="topBox">
        <span>项目概要：本次项目共计1577字，重复字数517字。</span>
        <button @click="getBut">统计下载</button>
      </div>
      <!-- 项目统计table 开始-->
      <template v-if="qwe">
        <el-table
          ref="projectTable"
          tooltip-effect="dark"
          style="width:100%"
          border
          class="tabTit"
        >
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="名称" width></el-table-column>
          <el-table-column label="创建时间" width="140"></el-table-column>
          <el-table-column label="总计" width="92"></el-table-column>
          <el-table-column label="0%-49%" width="100"></el-table-column>
          <el-table-column label="50%-74%" width="100"></el-table-column>
          <el-table-column label="75%-84%" width="100"></el-table-column>
          <el-table-column label="85%-99%" width="100"></el-table-column>
          <el-table-column label="100%" width="100"></el-table-column>
          <el-table-column label="文件内重复" width="124"></el-table-column>
          <el-table-column label="跨文件重复" width="124"></el-table-column>
          <el-table-column label="新建字数" prop="name" width="124"></el-table-column>
        </el-table>
      </template>
      <template v-if="qwe">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width:100%"
          border
          class="tabMain"
        >
          <el-table-column type="index" label width="80"></el-table-column>
          <el-table-column label="第三方案" width></el-table-column>
          <el-table-column label="2018-07-03" width="140"></el-table-column>
          <el-table-column label="15777" width="92"></el-table-column>
          <el-table-column label="15" width="100"></el-table-column>
          <el-table-column label="299" width="100"></el-table-column>
          <el-table-column label="33" width="100"></el-table-column>
          <el-table-column label="623" width="100"></el-table-column>
          <el-table-column label="15822" width="100"></el-table-column>
          <el-table-column label="25" width="124"></el-table-column>
          <el-table-column label="9" width="124"></el-table-column>
          <el-table-column label="100" prop="name" width="124"></el-table-column>
        </el-table>
      </template>
      <!-- 项目统计table 结束-->
      <!-- 译员统计table 开始-->
      <template v-if="!qwe">
        <el-table
          ref="interpreterTable"
          tooltip-effect="dark"
          style="width:100%"
          border
          :data="tableData"
          :span-method="arraySpanMethod"
        >
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="名称" width></el-table-column>
          <el-table-column label="完成时间" width="140"></el-table-column>
          <el-table-column label="任务类型" width="92"></el-table-column>
          <el-table-column label="原文字数" width="100"></el-table-column>
          <el-table-column label="译文字数" prop="qsq" width="124"></el-table-column>
          <el-table-column label="译员" prop="name" width="124"></el-table-column>
          <el-table-column label="单价/元" prop="address" width="124"></el-table-column>
          <el-table-column label="总价/元" prop="name" width="124"></el-table-column>
        </el-table>
      </template>
      <!-- 译员统计table 结束-->
    </main>
  </div>
</template>

<script>
export default {
  name: "statistics",
  // props: ["rowName"],
  data() {
    return {
    tableData: [
        {
          date: "2016-05-03",
          name: "小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "123",
        },
        {
          date: "2016-05-02",
          name: "李四 ",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "999"
        },
        {
          date: "2016-05-04",
          name: "王五",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "55"
        },
        {
          date: "2016-05-01",
          name: "张三",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "1203"
        },
        {
          date: "2016-05-08",
          name: "张三",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "22"
        },
        {
          date: "2016-05-06",
          name: "小虎还是你",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "22"
        },
        {
          date: "2016-05-07",
          name: "66",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "13"
        },
        {
          date: "2016-05-07",
          name: "qq",
          address: "上海市普陀区金沙江路 1518 弄",
          qsq: "3"
        }
      ],
      multipleSelection: [], // 存储选中的数组
      butClass: "",
      isShow: false,
      downloadBoxTit: "添加到记忆库",
      topText: "",
      botText: "q",
      isDel: false,
      statisticsTit: ["项目统计", "译员工作量"],
      titActiveI: "0",
      qwe:false,
      spanArr:[],
      pos:0,
    };
  },
  components: {},
  updated() {
    // console.log(rowName, "00");
  },
  created() {
     this.getSpanArr(this.tableData)
  },
  methods: {
    to(data){
      
      if (data==0) {
        this.qwe = true
        // console.log(data)
      }else{
        this.qwe = false;
        this.getSpanArr(this.tableData)
        // console.log(data,"0")
      }

    },
    // 返回上一页
    backtrack() {
      this.$router.go(-1);
    },
    // 下载
    getBut() {
      // console.log(this.rowName, "00");
    },
      // 合并列
    getSpanArr(data) {
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i].name === data[i - 1].name) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
        }
      },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) { // 对第六列合并
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
  }
};
</script>
<style lang="less" scoped>
.statistics {
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    span {
      float: left;
      margin-left: 50px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69,69,69,1);
    }
  }
  main {
    // width: 1660px;
    position: relative;
    // min-height: 789px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 38px;
    padding: 0 20px;
    h3 {
      //   text-align: left;
      height: 30px;
      padding-top: 12px;
      div {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        width: 92px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titActive {
        border-bottom: 1px solid rgba(69,69,69,1);
        color: rgba(69,69,69,1);
      }
    }
    .topBox {
      padding-top: 16px;
      span {
        float: left;
        font-size: 14px;
      }
      button {
        float: right;
        width: 92px;
        height: 32px;
        border: 0px;
        background:#5256E9;
        border-radius: 4px;
        margin-right: 0;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .tabTit {
      /deep/.el-table__body-wrapper {
        display: none;
      }
      /deep/.has-gutter {
        tr {
          th {
            border: 0px;
          }
        }
      }
    }
    .tabMain {
      /deep/.has-gutter {
        tr {
          th:nth-child(1) {
            // border-left: 1px solid #ebeef5;
          }
        }
      }
    }
    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    /deep/.has-gutter {
      tr {
        th {
          //   border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      padding: 0px !important;
      height: 46px;
    }
    .el-table td,
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
    }
    /deep/.el-table td:nth-child(3) {
      text-align: left;
    }
    /deep/.el-table td:nth-child(4) {
      text-align: left;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background:rgba(210,210,210,1);
    }
    /deep/.el-table {
      height: calc(100% - 56px);
      border: 0px;
      //   width: 1620px;
      .ass {
        border: 0px;
        padding: 5px;
        background: transparent;
      }
      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
    }
  }
}
</style>
<style lang="less">
</style>